import React, { Component } from "react";
import { connect } from "react-redux";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class AdrReviewSuccessModalV3 extends Component {
  state = {
    selectedAction: "closeAdr",
  };

  handleChange_action = (e) => this.setState({ selectedAction: e.target.name });

  handleClick_ok = (e) => {
    e.preventDefault();
    const { handleAlertAction } = this.props;
    const { selectedAction } = this.state;
    handleAlertAction(selectedAction);
  };

  render() {
    const { selectedAction } = this.state;
    const { showAlert_reviewSuccess, isApproved } = this.props;
    return (
      <Modal
        isOpen={showAlert_reviewSuccess}
        toggle={() => {}}
        className={this.props.className}
        fade={false}
        size={"md"}
      >
        <ModalHeader className="bg-success text-white">
          <FontAwesomeIcon icon="check" className="mr-2" />
          {isApproved ? "Accepted" : "Rejected"}
        </ModalHeader>
        <ModalBody>
          <div className="card">
            <div className="card-body">
              <p>
                This daily report is {isApproved ? "accepted" : "rejected"}. What would you like to
                do?
              </p>
              <div className="form-row">
                <div className="col">
                  <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                    <div className="radio">
                      <input
                        type="radio"
                        name="closeAdr"
                        id="closeAdr"
                        checked={selectedAction === "closeAdr"}
                        onChange={this.handleChange_action}
                        className="custom-control-input"
                      />
                      <label htmlFor="closeAdr" className="custom-control-label my-auto">
                        Close this daily report
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="col">
                  <div className="form-check-inline custom-control custom-radio mt-1 ml-2">
                    <div className="radio">
                      <input
                        type="radio"
                        name="openNext"
                        id="openNext"
                        checked={selectedAction === "openNext"}
                        onChange={this.handleChange_action}
                        className="custom-control-input"
                      />
                      <label htmlFor="openNext" className="custom-control-label my-auto">
                        Open next daily report to review
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="form-row form-group mb-0">
            <input
              className="btn btn-primary mr-2"
              name="closeAdrReviewSuccessModal"
              id="closeAdrReviewSuccessModal"
              type="button"
              onClick={this.handleClick_ok}
              value="OK"
            />
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export default connect()(AdrReviewSuccessModalV3);
